import React from "react";
import { motion } from "framer-motion";
import { Gift, Truck, ShieldCheck, Sparkles } from "lucide-react";
import { HERO_FLATLAY_URL } from "@/lib/api";

const features = [
  { icon: Sparkles, title: "Stocking Stuffers Included", text: "Every Christmas bouquet comes with extra stocking stuffer treats." },
  { icon: Gift, title: "Made-to-Order Bouquets", text: "Fall & Christmas candy bouquets, hand-built for everyone on your list." },
  { icon: Truck, title: "Local Pickup & Delivery", text: "Order online, we sort out the sweet handoff." },
  { icon: ShieldCheck, title: "Genuine U.S. Candy", text: "Iconic American candy you grew up loving — sealed fresh." },
];

export const AboutSection = () => {
  return (
    <section id="about" className="py-16 sm:py-24 bg-candy-bg/50 border-y-4 border-candy-pink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative"
        >
          <div className="absolute -inset-3 holo-bg rounded-3xl -rotate-2 border-4 border-black" />
          <img
            src={HERO_FLATLAY_URL}
            alt="The Sweet Tooth Bandit candy spread in glossy mylar packaging"
            className="relative rounded-2xl border-4 border-black shadow-brutal w-full object-cover"
          />
        </motion.div>

        <div>
          <span className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-candy-pink">
            Our Story
          </span>
          <h2 className="font-display text-5xl sm:text-6xl tracking-tight mt-1 text-candy-cream">
            A LITTLE SWEET, <br /> A LITTLE <span className="text-candy-teal">SNEAKY</span>
          </h2>
          <p className="mt-5 font-body font-medium text-candy-cream/80 leading-relaxed">
            The Sweet Tooth Bandit started as a candy sale on the kitchen table and grew
            into a full-blown holiday candy operation. We hunt down the iconic U.S. candy you
            crave and hand-build festive Fall &amp; Christmas candy bouquets, packed with
            stocking stuffers and made to order.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-4">
            {features.map((f, i) => (
              <div key={i} className="bg-candy-card border-4 border-candy-teal rounded-xl p-4 shadow-brutal-sm">
                <f.icon className="h-6 w-6 text-candy-pink" />
                <h3 className="font-heading font-600 mt-2 text-base text-candy-cream">{f.title}</h3>
                <p className="text-sm text-candy-cream/70 mt-1">{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
